'use es6';

import { renderRoot } from 'quartz-core/client';

//I18n Configuration
import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
import registerAllData from 'I18n/init/register/lazy/registerAllData';
import lang from 'i2l?query=sporks!../lang/admin/en.lyaml';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import UserContainer from 'documents-ui/lib/containers/UserContainer';
import GateContainer from 'documents-ui/lib/containers/GateContainer';
import { hasDocuments } from 'documents-ui/lib/permissions';
import { Application as ApplicationComponent } from 'foundations-components/components/Application';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import rhumbConfig from '../rhumb-config.yaml';
import { Provider } from 'react-redux';
import { initTracker } from 'documents-lib/js/tracking/tracker';
import configureStore from './utils/configureStore';
import { getRootUrl } from './utils/urls';
import { Router } from 'react-router-dom';
import routes from './Routes';
import { createBrowserHistory } from 'history';
import { ApolloProvider } from '@apollo/client';
import { createApolloClient } from 'hubspot-apollo-client';
import { CampaignsProvider } from 'campaigns-lib/campaignsPlatform';
import { DataFetchingClientProvider, DataFetchingClient } from 'data-fetching-client';
import SalesContentAppContainer from 'SalesContentIndexUI/containers/SalesContentAppContainer';
import { FeedbackLoaderProvider } from 'feedback-loader/FeedbackLoaderProvider';
import { jsx as _jsx } from "react/jsx-runtime";
const apolloClient = createApolloClient();
const dataFetchingClient = new DataFetchingClient();
export default class Application {
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    this.init().then(([authData]) => {
      setDocumentTitle('app.htmlTitle');
      this.startRedux({
        authData
      });
    }).catch(error => {
      console.error(error);
    });
  }
  init() {
    PortalIdParser.get();
    const I18nProvider = createStandardI18nProvider();
    const langAvailable = Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    userInfo().then(({
      user,
      portal
    }) => {
      I18nProvider.setLocale({
        locale: user.locale,
        langEnabled: user.lang_enabled,
        timezone: portal.timezone
      });
    }).catch(error => {
      console.error(error);
    });
    return Promise.all([userInfo(), langAvailable]);
  }
  startRedux({
    authData
  }) {
    UserContainer.set(authData.user);
    GateContainer.set(authData.gates);
    if (!hasDocuments()) {
      window.location.href = '/myaccounts';
      return;
    }
    this.store = configureStore({
      auth: authData
    });
    initTracker();
    this.startRouter();
  }
  startRouter() {
    const history = createBrowserHistory({
      basename: getRootUrl()
    });
    renderRoot( /*#__PURE__*/_jsx(ApplicationComponent, {
      name: "documents-ui",
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(FeedbackLoaderProvider, {
            children: /*#__PURE__*/_jsx(SalesContentAppContainer, {
              children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
                client: dataFetchingClient,
                children: /*#__PURE__*/_jsx(ApolloProvider, {
                  client: apolloClient,
                  children: /*#__PURE__*/_jsx(CampaignsProvider, {
                    children: /*#__PURE__*/_jsx(Router, {
                      history: history,
                      children: routes
                    })
                  })
                })
              })
            })
          })
        })
      })
    }));
  }
}